import { t } from '../strings';

/**
 * The replies beneath a note (piece 13; decision 0671): what the Note item's
 * thread reads, and the rules it draws by. 🔨 No DOM here: the rendering layer
 * is the web's, and this is the logic both the tile and the document panel share.
 */
export interface NoteReply {
  id: string;
  authorPersonId: string;
  author: string;
  /** When the reply was written, an instant the screen draws in the viewer's own zone. */
  at: string;
  body: string;
  /** Whether this viewer may delete it: its author or an administrator (decision 0671). */
  mayDelete: boolean;
}

/**
 * The replies a note row carries, read from its JSON. 🔨 A row that carries none,
 * or carries something that is not a list, reads as no replies rather than
 * failing the page.
 */
export function noteRepliesFrom(json: unknown): NoteReply[] {
  if (typeof json !== 'string' || !json) return [];
  try {
    const parsed = JSON.parse(json) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((row): row is NoteReply => typeof row === 'object' && row !== null && typeof (row as NoteReply).id === 'string' && typeof (row as NoteReply).body === 'string').map((row) => ({ ...row, mayDelete: row.mayDelete === true }));
  } catch {
    return [];
  }
}

/** 🔒 The folded note's line reads how many replies it carries; a note with none offers Reply. */
export function noteThreadToggleLabel(count: number, open: boolean): string {
  if (open) return t('note.reply.hide');
  if (count === 0) return t('note.reply.add');
  return `${count} ${count === 1 ? t('note.reply.one') : t('note.reply.many')}`;
}

/** 🔨 A reply is plain text and never empty; the refusal the box shows before anything is sent. */
export function noteReplyProblem(body: string): string | null {
  return body.trim() ? null : t('note.reply.empty');
}
